import { Component, Input, OnInit, OnChanges } from '@angular/core'
import { trigger, state, style, transition, animate } from '@angular/animations';
import publicHelpers from 'src/app/helpers/public-helpers';
import { Sponsor } from 'globals/store/sponsors.data';
import { LabelObject, Ranking } from 'globals/store/events.data';
import { CommonModule } from '@angular/common';
import { LabelsViewComponent } from 'src/app/components/label-marker/labels-view.component';
import { ExpandIconComponent } from 'src/app/components/icon/expand.icon.component';
import { SocialLinksComponent } from 'src/app/components/social-links/social-links.component';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';

@Component({
    selector: 'static-sponsor-cards',
    templateUrl: './static-sponsor-cards.html',
    styleUrls: ['../../components/performers/static-performer-cards.scss', 'static-sponsor-cards.scss'],
    animations: [
        trigger('drop', [
            state('expand', style({ height: '*' })),
            state('collapse, undefined, void', style({ height: '0', padding: 0 })),
            transition('* => *', [animate('300ms')]),
            transition('void => *', [animate('0ms')])
        ])
    ],
    standalone: true,
    imports: [CommonModule, IdsToItemsPipe, LabelsViewComponent, ExpandIconComponent, SocialLinksComponent, IdsToItemsPipe, ],
})
export class StaticSponsorCardsComponent implements OnInit, OnChanges { // overly complicated to start, but I know that this will likely get complicated very fast.
  @Input() allExpanded // can be overwritten for printing
  @Input() sponsorIds: string[]
  @Input() sponsors: { [sId: string]: Sponsor }
  @Input() condensedSponsors = true
  @Input() labelMap: LabelObject
  @Input() sponsorTypes: { [tId:string]: Ranking }
  @Input() sponsorsCustomTitle?: string;
  @Input() initialLimit = 0
  @Input() hideNames = false
  @Input() showEmpty = false
  limited = false
  expanded: { [sId:string]: boolean } = {}
  helpers = publicHelpers
  hide = true

  trackByItem(_, item) {
    return item // item is an id here
  }

  ngOnInit() {
    this.toShowOrNotToShow()
    this.limited = !!this.initialLimit
  }

  toShowOrNotToShow() {
    this.hide = !this.sponsorIds || !this.sponsors || !this.sponsorIds.filter(sId => !!this.sponsors[sId]).length
  }

  expand(event, sponsorId){
    if(event.stopPropagation) event.stopPropagation();
    this.expanded[sponsorId] = !this.expanded[sponsorId]
  }

  ngOnChanges(_) {
    setTimeout(() => this.toShowOrNotToShow(), 0) // simpler than dealing with the changes by name;  this is a small contained component so this should be okay
  }

}

